export default __webpack_public_path__ + "static/media/map.a0c517ca.svg";